<div class="modal-header container-fluid">
  <h4 class="modal-title header-2">{{ title }}</h4>
  <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
</div>
<div class="modal-body container-fluid overflow-auto w-100">
  @for(item of contentList; track item) {
  <div
    class="my-3 data-wrapper pb-3 d-flex"
    [ngClass]="{ 'flex-column': item?.type === 'ol' }"
  >
    <div class="header-5 content-title">{{ item?.name }}:</div>
    <div class="mx-3 flex-grow-1">
      <ng-container [ngSwitch]="item.type">
        <ng-container *ngSwitchCase="'ol'">
          <ol>
            @for(li of data[item.mapping]; track li) {
            <li>
              {{ li }}
            </li>
            }
          </ol>
        </ng-container>
        <ng-container *ngSwitchCase="'code-snippet'">
          <app-code-snippet [code]="data[item?.mapping]"></app-code-snippet>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <span class="content-wrapper">{{ data[item?.mapping] }}</span>
        </ng-container>
      </ng-container>
    </div>
  </div>
  }
</div>
